module.exports = __webpack_public_path__ + "e0e200cd79634a2f43112e5619883fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/hirakata.png
// module id = 73
// module chunks = 0